import React from "react";

export default function SQL_TABLE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_TABLE</h1>
      <p>This is the SQL_TABLE component generated from the SQL JSON.</p>
    </div>
  );
}
